import {DeviceId} from '@webmate-web-core/shared/types/ids';

export type WorkbenchConsoleEventType = 'rotate' | 'send-ctrl-alt-del' | 'fullscreen' | 'image-quality' | 'vnc' | 'tap'| 'drag' | 'swipe' | 'install-app' | 'specialkey' | 'requestKeyboardmapping' | 'responseKeyboardmapping' | 'toolbar:openScreenshot' | 'toolbar:openVideo'| 'screen-reader' | 'setInteractionType' | 'activate-hardware-scanner' | 'mediaBrowserImageSelection';

export interface WorkbenchConsoleEvent {
    type: WorkbenchConsoleEventType;
    targetDevice: DeviceId;
    payload?: any;
}

export abstract class WorkbenchConsole {
    abstract handleConsoleEvent(e: WorkbenchConsoleEvent);
}